import * as React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Button } from 'components/ui/button';
import { useUploadFile } from 'hooks/api/stock/useUpload';
import { useState } from 'react';
import { toast } from 'sonner';

type UploadFileProps = {
  ids: string[];
  clearAndCloseDrawer?: () => void;
};

export const UploadFile: React.FC<UploadFileProps> = ({
  ids,
  clearAndCloseDrawer,
}) => {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const { uploadFile } = useUploadFile();
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: (file: File) => uploadFile(ids, file),
    onSuccess: (data, variables) => {
      toast('Nota fiscal de cobertura enviada com sucesso');
      queryClient.invalidateQueries({ queryKey: ['getPendingStocks'] });
      clearAndCloseDrawer && clearAndCloseDrawer();
    },
    onError: (error) => {
      toast('Erro ao enviar nota fiscal de cobertura', {
        description: error.message,
      });
    },
  });

  const handleUpload = () => {
    if (selectedFile) {
      mutation.mutate(selectedFile);
      setSelectedFile(null);
    }
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setSelectedFile(e.target.files[0]);
    }
  };

  return (
    <div className="w-[720px] m-auto">
      <div>
        <input
          type="file"
          id="fileInput"
          style={{ display: 'none' }} // Ocultar o input padrão
          onChange={handleFileChange}
        />
        <label htmlFor="fileInput">
          <button
            className="w-full bg-gray-100 text-slate-500 m-auto mt-10 font-sans text-xs inline-block h-20"
            onClick={(e) => {
              e.preventDefault();
              const fileInput = document.getElementById('fileInput');
              if (fileInput) {
                fileInput.click();
              }
            }}
          >
            {selectedFile
              ? selectedFile.name
              : 'Clique para fazer o upload da nota fiscal de cobertura'}
          </button>
        </label>
      </div>
      <Button
        size="default"
        className="w-full bg-emerald-600 text-slate-100 m-auto mt-4 font-GilroySemibold text-sm p-6 flex gap-2 hover:bg-emerald-800 transition-all"
        onClick={handleUpload}
        disabled={mutation.isPending || !selectedFile}
      >
        Enviar
      </Button>
    </div>
  );
};
